// Unsaved-changes tracking for the product section edit pages.
//
// Dirty state comes from comparing the form's serialization against a
// snapshot taken at page load — event listeners only decide WHEN to look, so
// widgets with odd event behavior (summernote, tagify) can't fool the
// navigation warning. Autosave is opt-in per product, remembered in
// localStorage, and submits the form over fetch as JSON.
//
// The FAQ fields are manual-save only, so snapshot() splits the form in two:
// the `form` half covers the autosaved fields and drives autosave, the `faq`
// half only drives the leave-the-page warning.
var state = {
  form: null,
  initial: null,
  initialFaq: null,
  autosave: false,
  submitting: false,
  saving: false,
  timer: null,
}

var AUTOSAVE_DELAY = 2500
var FAQ_PARAM_PREFIX = "product[faqs_attributes]"

function autosaveKey() {
  return "creatorAutosave:" + $(state.form).data("product-id")
}

function isFaqParam(key) {
  return key.indexOf(FAQ_PARAM_PREFIX) === 0
}

// Both halves of the form from ONE walk of the fields: what autosave sends, and
// the FAQ fields it deliberately leaves behind. This runs on every keystroke, so
// it serializes once and partitions — never once per half.
//
// Some load-time JS rewrites field values without any user edit, which would
// read as unsaved changes forever — normalize those out of the comparison:
// jquery-ujs swaps every form's per-form CSRF token for the meta tag's global
// one, and tagify (on its own timer) rewrites "a,b" to '[{"value":"a"},…]'.
function snapshot() {
  var autosaved = new URLSearchParams()
  var faqs = new URLSearchParams()
  new URLSearchParams($(state.form).serialize()).forEach(function (value, key) {
    if (isFaqParam(key)) faqs.append(key, value)
    else autosaved.append(key, value)
  })

  autosaved.delete("authenticity_token")
  var tags = autosaved.get("product[tags]")
  if (tags && tags.charAt(0) === "[") {
    try {
      var plain = JSON.parse(tags)
        .map(function (tag) {
          return tag.value
        })
        .join(",")
      autosaved.set("product[tags]", plain)
    } catch {
      // not tagify's format after all — compare it verbatim
    }
  }

  return { form: autosaved.toString(), faq: faqs.toString() }
}

// Which halves have unsaved edits. Pass a snapshot to reuse one already taken;
// callers that need both answers must, or they pay for the walk twice.
function dirtyState(snap) {
  if (!state.form || !document.body.contains(state.form)) {
    return { form: false, faq: false }
  }
  snap = snap || snapshot()
  return {
    form: state.initial !== null && snap.form !== state.initial,
    faq: state.initialFaq !== null && snap.faq !== state.initialFaq,
  }
}

function isDirty() {
  return dirtyState().form
}

function shouldWarn() {
  if (state.submitting) return false
  var dirty = dirtyState()
  // Autosave covers every field except the FAQs, which only a manual save
  // persists — so with autosave on, they are the only thing left to warn about.
  if (state.autosave) return dirty.faq
  return dirty.form || dirty.faq
}

function showNote(kind) {
  $(".js-savebar-dirty, .js-savebar-saved, .js-savebar-failed").addClass(
    "d-none"
  )
  if (kind) $(".js-savebar-" + kind).removeClass("d-none")
}

function refreshDirtyState() {
  if (!state.form) return
  var dirty = dirtyState()
  if (dirty.form || dirty.faq) {
    showNote("dirty")
    if (state.autosave && dirty.form) scheduleAutosave()
  } else {
    showNote(null)
  }
}

function scheduleAutosave() {
  clearTimeout(state.timer)
  state.timer = setTimeout(performAutosave, AUTOSAVE_DELAY)
}

// FAQ edits are manual-save only — Creator::ProductSectionsController drops
// faqs_attributes from JSON PATCHes, so don't send them either. A half-typed row
// would otherwise be INSERTed mid-keystroke; the form's hidden id field stays
// blank, so the next autosave INSERTs a second copy instead of updating it.
function autosavePayload(form) {
  var payload = new FormData()
  new FormData(form).forEach(function (value, key) {
    if (!isFaqParam(key)) payload.append(key, value)
  })
  return payload
}

function performAutosave() {
  if (!state.form || !state.autosave || state.saving || !isDirty()) return

  var form = state.form
  var payload = autosavePayload(form)
  state.saving = true

  fetch(form.action, {
    method: "POST", // _method=patch rides along in the FormData
    body: payload,
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then(function (response) {
      return response.json()
    })
    .then(function (data) {
      state.saving = false
      if (data.success) {
        var snap = snapshot()
        state.initial = snap.form
        // Never advance the FAQ baseline here: the server did not save those
        // fields, so they are still genuinely unsaved.
        showNote(dirtyState(snap).faq ? "dirty" : "saved")
        if (data.reload) {
          Turbolinks.visit(window.location.href, { action: "replace" })
        }
      } else {
        showNote("failed")
      }
    })
    .catch(function () {
      state.saving = false
      showNote("failed")
    })
}

$(document).on("turbolinks:load", function () {
  clearTimeout(state.timer)
  state.form = document.querySelector(".js-section-form")
  state.submitting = false
  state.saving = false
  if (!state.form) return

  state.autosave = localStorage.getItem(autosaveKey()) === "1"
  $(".js-autosave-toggle").prop("checked", state.autosave)
  showNote(null)

  // Take the baseline once the rest of the page's load work has run: widgets
  // initialized by later turbolinks:load handlers (tagify rewriting the tags
  // input to JSON, for one) mutate field values, and a baseline captured
  // before them reads as unsaved changes forever.
  state.initial = null
  state.initialFaq = null
  var form = state.form
  setTimeout(function () {
    if (state.form !== form) return
    var snap = snapshot()
    state.initial = snap.form
    state.initialFaq = snap.faq
  }, 0)
})

// Serialization can't see a keystroke until something fires, so listen wide:
// summernote/tagify emit their own events, everything else bubbles keyup.
$(document).on(
  "input change keyup summernote.change",
  ".js-section-form",
  refreshDirtyState
)

$(document).on("change", ".js-autosave-toggle", function () {
  state.autosave = $(this).is(":checked")
  if (!state.form) return
  localStorage.setItem(autosaveKey(), state.autosave ? "1" : "0")
  if (state.autosave) refreshDirtyState()
})

$(document).on("submit", ".js-section-form", function () {
  state.submitting = true
  clearTimeout(state.timer)
})

// With autosave on, leaving mid-debounce would silently drop the pending
// changes — save them on the way out instead of warning. keepalive lets the
// request finish after the page is gone. FAQ fields are excluded here too, so
// the caller still has to check shouldWarn() afterwards.
function flushAutosave() {
  if (!state.form || !state.autosave || state.submitting) return

  var snap = snapshot()
  if (!dirtyState(snap).form) return

  clearTimeout(state.timer)
  state.initial = snap.form
  fetch(state.form.action, {
    method: "POST", // _method=patch rides along in the FormData
    body: autosavePayload(state.form),
    credentials: "same-origin",
    keepalive: true,
    headers: {
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).catch(function () {})
}

document.addEventListener("turbolinks:before-visit", function (event) {
  flushAutosave()
  if (
    shouldWarn() &&
    !confirm(
      "You have unsaved changes on this page. Leave without saving them?"
    )
  ) {
    event.preventDefault()
  }
})

window.addEventListener("beforeunload", function (event) {
  flushAutosave()
  if (shouldWarn()) {
    event.preventDefault()
    event.returnValue = ""
  }
})
